module.exports = __webpack_public_path__ + "img/avatar_2@2x.9472a16c.png";